<template>
  <Modal title="规则详情" width="758" v-model="state" transfer>
    <Table :columns="columns" :data="data">
      <template slot-scope="{ row }" slot="monitorTime">
        <div class="m-condition">
          <span>{{ row['monitorTime'] | timeType }}</span>
        </div>
      </template>
      <template slot-scope="{ row }" slot="ruleType">
        <div class="m-condition">
          <span>{{ row['ruleType'] }}<br />{{ row['ruleTypeInfoDesc'] }}</span>
        </div>
      </template>
      <template slot-scope="{ row }" slot="monitorConditionDesc">
        <div class="m-condition">
          <span class="block-span g-error-text">{{ row['monitorRange'] }}</span>
          <span class="block-span" v-for="(cond, i) in row['monitorConditionDesc']" :key="i">{{ cond }}</span>
        </div>
      </template>
    </Table>
    <template slot="footer">
      <Button type="primary" @click="$emit('input', false)">知道了</Button>
    </template>
  </Modal>
</template>
<script>
export default {
  name: 'ruleDetail',
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  filters: {
    timeType(val) {
      let timeTxt = ''
      const { key, value } = val
      if (key && key === 'half') timeTxt = '每半个小时'
      else if (key && key === 'fiveMin') timeTxt = '每5分钟'
      else if (key && key === 'quarter') timeTxt = '每15分钟'
      else if (key && key === 'day') timeTxt = `每天 ${value}`
      return timeTxt
    }
  },
  data() {
    return {
      columns: [
        {
          title: '规则名称',
          key: 'ruleName'
        },
        {
          title: '触发条件',
          key: 'monitorConditionDesc',
          slot: 'monitorConditionDesc',
          width: 220
        },
        {
          title: '规则类型',
          key: 'ruleType',
          slot: 'ruleType'
        },
        {
          title: '监控频率',
          key: 'monitorTime',
          slot: 'monitorTime'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.block-span {
  display: block;
}

.m-condition {
  padding: 8px 0;
}
</style>
